export const useUser = () => {
  const config = useRuntimeConfig().public
  const client = useFetchClient(config.userapiMajorityUrl, 'User API Majority')

  const verifyEmail = async (id, secret) => {
    const url = '/v1/emailverification'
    const ignoreSentry = true;
    await client.put(url, { id, secret }, ignoreSentry)
  }

  const submitOTP = async (payload) => {
    const url = '/v1/auth/signin-web/sms'
    const data = await client.put(url, payload)
    return data
  }

  const getOTP = async (payload) => {
    const url = '/v2/auth/signup/signin/sms'
    return await client.post(url, payload)
  }

  const supplyUserDetails = async (payload, accessToken) => {
    const url = '/v1/web-signup/users'

    const config = { Authorization: `Bearer ${accessToken}` }

    await client.post(url, payload, config)
  }

  const getUserDetails = async (accessToken) => {
    const url = '/v1/web-signup/users'

    const config = { Authorization: `Bearer ${accessToken}` }

    const data = await client.get(url, config)
    return data
  }

  return {
    verifyEmail,
    submitOTP,
    getOTP,
    supplyUserDetails,
    getUserDetails
  }
}
